import { VendorDashboardPage } from "@/features/vendor-app/pages/VendorDashboardPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/dashboard")({
	component: VendorDashboardPage,
});
